'use client'

import { Box, useGraphicPreview } from '@/lib/features/graphic/GraphicPreviewContext'
import React from 'react'

interface GraphicPreviewOverlayProps {
  // Text editing handlers
  onEditingTextChange: (text: string) => void
  onSaveEditedText: () => void
  onEditKeyDown: (event: React.KeyboardEvent) => void
}

export default function GraphicPreviewOverlay({
  onEditingTextChange,
  onSaveEditedText,
  onEditKeyDown,
}: GraphicPreviewOverlayProps) {
  const { highlightBoxes, editingNode, editingText, editingBox } = useGraphicPreview()

  return (
    <>
      {/* Highlight overlays for selected elements */}
      {highlightBoxes.map((box: Box, index: number) => (
        <div
          key={index}
          className="pointer-events-none absolute z-10 border-2 border-dashed border-blue-500 bg-blue-100 bg-opacity-20"
          style={{
            top: `${box.top}px`,
            left: `${box.left}px`,
            width: `${box.width}px`,
            height: `${box.height}px`,
          }}
        />
      ))}

      {/* Text editing overlay */}
      {editingNode && editingBox && (
        <div
          className="absolute z-30"
          style={{
            top: `${editingBox.top}px`,
            left: `${editingBox.left}px`,
            width: `${editingBox.width}px`,
            height: `${editingBox.height}px`,
          }}
        >
          <textarea
            value={editingText}
            onChange={(e) => onEditingTextChange(e.target.value)}
            onBlur={onSaveEditedText}
            onKeyDown={onEditKeyDown}
            className="h-full w-full resize-none overflow-auto border-2 border-orange-500 bg-white px-1 text-black outline-none"
            style={{
              fontSize: 'inherit',
              fontFamily: 'inherit',
              lineHeight: 'inherit',
            }}
            autoFocus
          />
        </div>
      )}
    </>
  )
}
